import React from 'react';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { useRestreamingControl } from 'features/toolbar/toolbar/controls/restreaming/useRestreamingControl';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';

const RestreamingControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const { toggleRestreaming, status, icon, label, badgeColor, isFeatureAvailable } =
    useRestreamingControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    toggleRestreaming();
  };

  return (
    <MobileMenuItem
      id="restreamer-control"
      icon={icon}
      disabled={status === 'starting'}
      onClick={handleClick}
      badgeActive
      BadgeProps={{
        invisible: status === 'stopped',
        variant: 'dot',
        color: badgeColor,
      }}
    >
      {label}
    </MobileMenuItem>
  );
};

export default RestreamingControlMobile;
